/*
 *  Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

export const getCalendlyDataFromServiceWorldCalendlyUrl = (serviceWorldCalendlyUrl: string) => {

  const splitCalendlyUrlByParams = serviceWorldCalendlyUrl.split("?");
  const splitCalendlyUrlBySlashes = splitCalendlyUrlByParams[0].split("/");

  return {
    responsibleParty: splitCalendlyUrlBySlashes[splitCalendlyUrlBySlashes.length - 2],
    appointmentType: splitCalendlyUrlBySlashes[splitCalendlyUrlBySlashes.length - 1],
    utmSource: new URLSearchParams(splitCalendlyUrlByParams[1]).get("utm_source"),
  };
};
